__turbopack_context__.v({
  "className": "geist_mono_c3c59adc-module__hzJqUG__className",
  "variable": "geist_mono_c3c59adc-module__hzJqUG__variable",
});
